import {
  gallery_default
} from "./chunk-FFTAF554.js";

// src/layouts/gallery/index.ts
var gallery_default2 = gallery_default;

export {
  gallery_default2 as gallery_default
};
